const OnboardingStep = Object.freeze({
  PROFILE: 'profile',
  CONSENTS: 'consents',
  FINISHED: 'finished'
} as const)

export type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep];
export default OnboardingStep
